import React from "react"
import { useTheme } from "@mui/material/styles"
import { Grid } from "@mui/material"

import { STATE_SHORT_TO_LONG } from "../../content"
import { GenericStringObj } from "../../types"
import CoursePreviewBlock from "./CoursePreviewBlock"
import { landingPageMeta } from "./drivers-ed/content"
import Section from "./product-marketing/Section"

/**
 * This component can be used on location landing pages, or anywhere
 * that we have a state, and is a call to action for Drivers Ed
 * specifically (though really any course) in that state.
 */

type Props = {
  usState: string
}

const stateNameMapping: GenericStringObj = STATE_SHORT_TO_LONG

const CoursesInStateCTA = ({ usState }: Props) => {
  const theme = useTheme()
  const stateCourses = landingPageMeta[usState]

  if (!stateCourses) return null

  const stateName = stateNameMapping[usState.toUpperCase()]

  return (
    <Section
      head={`Drivers Ed in ${stateName}`}
      subhead="We offer premium online courses in your state!"
      style={{
        background: theme.palette.primary.main,
        color: "#ffffff",
      }}
    >
      <Grid container spacing={2} justifyContent="center">
        {stateCourses.map((stateCourse, i) => (
          <CoursePreviewBlock key={i} course={stateCourse} state={usState} />
        ))}
      </Grid>
    </Section>
  )
}

export default CoursesInStateCTA
